export enum idStateDocumentWizard {
  CaricatoInSide = '0',
  Ricevuto = '1',
  Verifica = '2',
  Inserito = '3',
  Rifiutato = '4',
  Altro = '5',
  Validato = '6',
  AttesaDiValidazione = '7',
  RitentaValidazione = '8',
}

export const getStateDocumentWizard = (id?: string): string => {
  if (!id) {
    return '';
  }

  switch (id) {
    case idStateDocumentWizard.CaricatoInSide:
      return 'Caricato in SIDE';
    case idStateDocumentWizard.Ricevuto:
      return 'Ricevuto';
    case idStateDocumentWizard.Verifica:
      return 'In corso di verifica';
    case idStateDocumentWizard.Inserito:
      return 'Inserito';
    case idStateDocumentWizard.Rifiutato:
      return 'Rifiutato';
    case idStateDocumentWizard.Altro:
      return 'Altro';
    case idStateDocumentWizard.Validato:
      return 'Validato';
    case idStateDocumentWizard.AttesaDiValidazione:
      return 'In attesa di validazione';
    case idStateDocumentWizard.RitentaValidazione:
      return 'Ritenta validazione';
    default:
      return '';
  }
};
